import React from 'react';
import styles from './AboutMe.module.css';

function Header() {
  return (
    <div className={styles.headerContainer}>
        <h1 className={styles.header}> Krisztian Gal </h1>
    </div>
  )
};

export default Header;
